import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'carbon-components-react';
import { CaretLeft16, CaretRight16 } from '@carbon/icons-react';

const CustomPagination: React.FC<Props> = ({
  page,
  pageSize,
  totalItems,
  baseMapTheme,
  onPageChange
}) => {
  const [backButtonDisabled, setBackButtonDisabled] = useState<boolean>(true);
  const [forwardButtonDisabled, setForwardButtonDisabled] = useState<boolean>(
    true
  );
  const [totalPage, setTotalPage] = useState<number>(1);

  useEffect(() => {
    const totalPage =
      totalItems % pageSize > 0
        ? parseInt((totalItems / pageSize).toString()) + 1
        : parseInt((totalItems / pageSize).toString());
    setBackButtonDisabled(page <= 1);
    setForwardButtonDisabled(page >= totalPage);
    setTotalPage(totalPage);
  }, [page, totalItems, pageSize]);

  const handleChangePage = (page: number) => {
    const newPage = page < 1 ? 1 : page > totalPage ? totalPage : page;
    onPageChange(newPage);
  };

  return (
    <div className="bx--pagination">
      <div className="bx--pagination__left">
        <div className="legend-box">
          <div className="legend--current">
            <span>
              <div
                className={`line${baseMapTheme === 'dark' ? ' dark' : ''}`}
              />
            </span>
            <span>Current AOI</span>
          </div>
          <div className="legend--history">
            <span>
              <div
                className={`line${baseMapTheme === 'dark' ? ' dark' : ''}`}
              />
            </span>
            <span>Historical AOI</span>
          </div>
        </div>
      </div>
      <div className="bx--pagination__right">
        <span className="bx--pagination__text">Page {page}</span>
        <div className="bx--pagination__control-buttons">
          <Button
            kind="ghost"
            className={`bx--pagination__button bx--pagination__button--backward${
              backButtonDisabled ? ' bx--pagination__button--no-index' : ''
            }`}
            hasIconOnly={true}
            renderIcon={CaretLeft16}
            iconDescription="Previous page"
            tooltipAlignment="center"
            tooltipPosition="top"
            onClick={() => handleChangePage(page - 1)}
            disabled={backButtonDisabled}
          />
          <Button
            kind="ghost"
            className={`bx--pagination__button bx--pagination__button--forward${
              forwardButtonDisabled ? ' bx--pagination__button--no-index' : ''
            }`}
            hasIconOnly={true}
            renderIcon={CaretRight16}
            iconDescription="Next page"
            tooltipAlignment="end"
            tooltipPosition="top"
            onClick={() => handleChangePage(page + 1)}
            disabled={forwardButtonDisabled}
          />
        </div>
      </div>
    </div>
  );
};

const propTypes = {
  page: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  baseMapTheme: PropTypes.string
};

type Props = PropTypes.InferProps<typeof propTypes>;

CustomPagination.propTypes = propTypes;

CustomPagination.defaultProps = {
  page: 1,
  pageSize: 1,
  totalItems: 0
};

export default React.memo(CustomPagination);
